<template>
  <div class="page">
    <van-nav-bar title="免实习申请" left-arrow @click-left="$router.go(-1)" fixed :placeholder="true" :safe-area-inset-top="true" />
    <div class="bblock">学生信息</div>
    <van-field  v-model="dataForm.yx" name="所属院系" label="所属院系" input-align="right" error-message-align="right" readonly />
    <van-field label-width="8em" v-model="dataForm.ksnd" name="上课年级" label="上课年级" input-align="right" error-message-align="right" readonly />
    <van-field label-width="8em" v-model="dataForm.zymc" name="上课专业" label="上课专业" input-align="right" error-message-align="right" readonly />
    <van-field label-width="8em" v-model="dataForm.bj" name="上课班级" label="上课班级" input-align="right" error-message-align="right" readonly />
    <van-field label-width="8em" v-model="dataForm.dh" name="联系电话" label="联系电话" input-align="right" error-message-align="right" readonly />
    <div class="bblock">免实习申请信息</div>
    <van-form @submit="onSubmit">
      <van-field required v-model="form.sqyy" rows="1" autosize label="申请原因" input-align="right" error-message-align="right" type="textarea" placeholder="请输入" :rules="[{ required: true, message: '请输入申请原因' }]" />
      <!-- <van-field required readonly clickable name="calendar" :value="where" label="去向" input-align="right" is-link error-message-align="right" placeholder="请选择" @click="showPicker = true" :rules="[{ required: true, message: '请选择去向' }]" /> -->
      <van-field required name="uploader" label="证明文件" :rules="[{ required: true, message: '请上传证明文件' }]">
        <template #input>
          <van-uploader accept="image/*" :max-size="5 * 1024 * 1024" @oversize="$toast('文件大小不能超过 5M ')" :max-count="1" :after-read="upload" v-model="fileList" />
        </template>
      </van-field>
      <div class="button-box-submit">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <!-- 选择去向 -->
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="whereList" @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>
     <!-- 选择审批人 -->
    <van-popup v-model="showPicker2" round position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="showPicker2 = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="saveData()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            @click="personTap($event, index)"
            v-for="(item, index) in userList"
            :key="item.userid"
          >
            {{ item.userrealname }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import  iApi  from '@/utils/internship'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      isEdit: false,
      showPicker: false,
      fileList: [],
      where: '',
      whereList: [],
      showPicker2: false,
      userList: [],
      dataForm: {
        bj: '',
        dh: '',
        ksnd: '',
        sxfzid: '',
        xh: '',
        xm: '',
        xnxq: '',
        yx: '',
        zymc: '',
      },
      form: {
        xnxq: '', // 学年详情
        xs0101id: '', // 学生id
        lxfs: '', // 联系方式
        sqyy: '', // 申请原因
        qx: '', // 去向id
        file: '', // 文件路径
        sxfzid: '', // 实习分组id
        sxjhid: '', // 实习计划id
        sxfs: '', // 分散状态
        userid: '',
        type: 'add',
        msxsqid: ''
      },
    }
  },
  computed: {
    ...mapGetters({
      sxjhid: 'getSxjhid',
      isty: 'getIsty',
    }),
  },
  methods: {
    // 获取预置数据
    async getPreInfo() {
      const res = await iApi.getPreInfo({ isty: this.isty, sxjhid: this.sxjhid })
      // 数据展示预置数据
      this.whereList = res.data.qx
      let list = Object.keys(this.dataForm)
      list.forEach(item => {
        if (this.dataForm[item] != undefined) {
          this.dataForm[item] = res.data[item]
        }
      })
      // 非编辑模式下获取数据
      if (!this.isEdit) {
        // 提交表单预置数据
        this.form = {
          xnxq: res.data.xnxq, // 学年详情
          xs0101id: res.data.xh, // 学生id
          lxfs: res.data.dh, // 联系方式
          sqyy: '', // 申请原因
          qx: '', // 去向id
          sxfzid: res.data.sxfzid, // 实习分组id
          sxjhid: this.sxjhid, // 实习计划id
          sxfs: '', // 分散状态
          userid: '',
          file: '',
          type: 'add',
          msxsqshid: ''
        }
      } else {
        const detail = await iApi.getRefreeApplyInfo({sxjhid: this.sxjhid})
        console.log(detail)
        // 编辑模式下获取数据
        this.form = {
          xnxq: res.data.xnxq, // 学年详情
          xs0101id: res.data.xh, // 学生id
          lxfs: res.data.dh, // 联系方式
          sqyy: detail.data.sqyy, // 申请原因
          qx: detail.data.qx, // 去向id
          sxfzid: res.data.sxfzid, // 实习分组id
          sxjhid: this.sxjhid, // 实习计划id
          sxfs: '', // 分散状态
          file: '',
          type: 'edit',
          msxsqshid: detail.data.msxsqshid
        }
        this.where = detail.data.qxmc
        this.fileList.push({
          content: detail.data.base64
        })
      }
      this.isty == 1 ? (this.form.sxfs = 1) : (this.form.sxfs = 2)
    },
    //选择去向
    onConfirm(data) {
      this.form.qx = data.value
      this.where = data.text
      this.showPicker = false
    },
    upload(e) {
      this.form.file = e.file
    },
    personTap(e, res) {
      console.log(e,res)
      let strList = [];
      let idList = [];
      if (this.userList[res].isBtn == 0) {
        this.userList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.userList[res].isBtn == 1) {
        this.userList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.userList) {
        // if (this.userList[res].userrealname == "全部") {
        //   this.userList[i].isBtn = 0;
        //   this.userList[res].isBtn = 1;
        //   this.$refs.person[res].className = "cur";
        //   this.$refs.person[i].className = "per-btn";
        // } else {
        //   this.userList[0].isBtn = 0;
        //   this.$refs.person[0].className = "per-btn";
        // }
        if (this.userList[i].isBtn == 1) {
          strList = strList.concat(this.userList[i].userrealname);
          idList = idList.concat(this.userList[i].userid);
        }
      }
      this.form.userid = idList.toString();
    },
    async onSubmit() {
      // 弹出审批人弹窗
      this.userList = []
      const res = await iApi.getReviewer({ywcode: 668})
      console.log(res)
      this.showPicker2 = true
      this.userList = this.userList.concat(res.data) 
      this.userList.forEach((item, index)=>{
        this.userList[index].isBtn = 0
      })
      
    },
    async saveData(){
      this.showPicker2 = false
      if(this.form.userid == null || this.form.userid == ''){
        this.$toast.fail("请选择审核人!");
        return null;
      }
      if (!this.isEdit) {
        const res = await iApi.setFreeApplyInfo(this.form)
        if (res.code == 1) {
          this.$toast.success('提交申请成功')
          setTimeout(() => {
            this.$router.replace({
              path: '/internship/applyStatus?config=3',
            })
          }, 800)
        }
      } else {
        const res = await iApi.setFreeApplyInfo(this.form)
        if (res.code == 1) {
          this.$toast.success('重新申请成功')
          setTimeout(() => {
            this.$router.go(-1)
          }, 800)
        }
      }
    }
  },
  created() {
    this.getPreInfo()
    if (this.$route.query.isEdit) {
      this.isEdit = true
    }
  },
}
</script>

<style lang="less" scoped>
.img-icon {
  height: 20px;
}
.van-tabs__line {
  background-color: #0088f8 !important;
  width: 25px;
}
.van-tab--active {
  color: #333333 !important;
  font-weight: 600 !important;
}
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
  .bblock {
    height: 40px;
    background: #f2f2f4;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    // padding-left: 15px;
    line-height: 50px;
    margin-left: 15px;
  }
}
.van-field__label {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px !important;
  span {
    color: #333333 !important;
  }
}
.van-icon {
  color: rgb(223, 224, 240) !important;
}
.button-box-submit {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 70px;
  background: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
  border: none !important;
  // border-color: #ffffff;
}
.van-button {
  width: 345px;
  height: 50px;
  border: 1px solid #e5e5e5;
  border-radius: 25px !important;
}
.apply-pop {
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  max-height: 40%;
  overflow-y: scroll;
}
.close-icon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.pop-title {
  display: flex;
  justify-content: space-between;
  padding: 13px;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  z-index: 9;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
}
.confirm-icon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.person {
  padding: 20px 20px 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: 48px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 15px;
}
.apply-pop .person .per-btn {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.person .cur {
  background-color: @attendance-background-color-1;
  color: @attendance-background-color-7;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/exemptionApplication.vue